<template>
    <VJoyPanel>
        <template #panel-title><h2>Invitation point</h2></template>
        <template #panel-body>
            <p>Please be sure that the invitee has validated his account (aka email validated)</p>
            <VJoyLink :href="adminLink">Current point attribution</VJoyLink>
            <VJoyInput
                v-model="accountId"
                label="Enter accountId (must have 24 characters) of the invitee to maybe attribute invitation point"
                name="accountId"
                @update:model-value="checkValidity"
            ></VJoyInput>
            <VJoyButton :loading="isLoading" :disabled="disableSent" @click="submitInvitationPoint">Sent</VJoyButton>
        </template>
    </VJoyPanel>
</template>

<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {computed, useGuestHost, ref} from '#imports';
    import {pushVJoySnackbar, VJoyButton, VJoyPanel, VJoyLink, VJoyInput} from '@maltjoy/core-vue';
    import {Configuration, DevToolsApi} from '@api';
    import {useProfileStore} from '~/store/profileStore';

    const {profile} = storeToRefs(useProfileStore());

    const accountId = ref('');
    const disableSent = ref(true);
    const isLoading = ref(false);
    const adminLink = computed(() => `${useGuestHost()}/admin/loyalty?profileId=${profile.value?.profileId}`);

    function checkValidity() {
        disableSent.value = accountId.value.length !== 24;
    }

    async function submitInvitationPoint() {
        if (accountId.value.length !== 24) {
            disableSent.value = true;
            return;
        }
        isLoading.value = true;
        try {
            await new DevToolsApi(new Configuration({basePath: ''})).fixInvitation({profileId: profile.value!.profileId, body: accountId.value});
            accountId.value = '';
            disableSent.value = true;
            pushVJoySnackbar({
                props: {
                    message: 'Request send successfully',
                    level: 'success',
                },
            });
        } catch (e) {
            pushVJoySnackbar({
                props: {
                    message: 'Error: are you sure about the account id you provide?',
                    level: 'error',
                },
            });
        } finally {
            isLoading.value = false;
        }
    }
</script>
